import { useState } from "react";
import { ScreenBackground } from "../shared/ScreenBackground";
import { screens } from "../../constants/constants";
import { useWindowSize } from "../../hooks/useWindowSize";
import { ScreenMenuArrowColum } from "./components/ScreenMenuArrowColum";
import { ScreenMenuColumns } from "./components/ScreenMenuColumns";
import { OnCurtainStart } from "../../types/types";

export const ScreenMenu = ({
  isCurtainActive,
  isCurtainIntro,
  onCurtainStart,
}: {
  isCurtainActive: boolean;
  isCurtainIntro: boolean;
  onCurtainStart: OnCurtainStart;
}) => {
  const background = `
    radial-gradient(circle at 50% 0%, #9856E955 0, transparent 50%),
    radial-gradient(circle at 50% 0%, #624781bb 0, transparent 90%),
    linear-gradient(#2E2564, #24143A)
    `;
  const [active, setActive] = useState(0);
  // console.log({ active });

  const { vertical }: any = { ...useWindowSize() };

  /* 
    !isCurtainActive reveal content after curtain animated out
    (isCurtainActive && isCurtainIntro) when moving to next screen still show content
  */
  const isContentShown =
    !isCurtainActive || (isCurtainActive && isCurtainIntro);

  return (
    <>
      <ScreenBackground
        {...{
          background,
          screenName: screens.menu,
          gridArea: "AppContentContainer",
        }}
      />
      {isContentShown && (
        <div
          style={{
            gridArea: "AppContentContainer",
            width: "100%",
            height: "100%",
            display: "grid",
            gridTemplateColumns: "20% 80%",
          }}
        >
          <ScreenMenuArrowColum
            {...{
              active,
              setActive,
              onCurtainStart,
              // screenTransition,
              // screenTransitionDelay
            }}
          />
          <ScreenMenuColumns
            {...{
              active,
              setActive,
              onCurtainStart,
            }}
          />
        </div>
      )}
    </>
  );
};
